export default function ShebaFintechPhoneIcon() {
  return (
    <>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.4454 3.81442C16.7168 4.15636 17.8761 4.82638 18.8071 5.75736C19.738 6.68835 20.4081 7.84761 20.75 9.11904M14.6687 6.71292C15.4316 6.91808 16.1271 7.32009 16.6857 7.87868C17.2443 8.43727 17.6463 9.13283 17.8515 9.89569M9.16965 11.7659C9.94762 13.3564 11.2369 14.6398 12.8309 15.4105C12.9475 15.4657 13.0765 15.4897 13.2052 15.4799C13.3339 15.4702 13.4579 15.4271 13.5648 15.3549L15.9119 13.7898C16.0157 13.7206 16.1352 13.6784 16.2594 13.667C16.3837 13.6556 16.5088 13.6753 16.6235 13.7245L21.0144 15.6063C21.1636 15.6697 21.2881 15.7798 21.3693 15.9201C21.4504 16.0604 21.4838 16.2233 21.4643 16.3841C21.3255 17.4701 20.7956 18.4683 19.9739 19.1918C19.1521 19.9152 18.0948 20.3144 17 20.3144C13.6185 20.3144 10.3755 18.9711 7.98439 16.58C5.5933 14.1889 4.25 10.9459 4.25 7.56442C4.25006 6.46959 4.64918 5.41231 5.37264 4.59056C6.0961 3.7688 7.09428 3.23893 8.18028 3.10014C8.34117 3.08067 8.50403 3.11402 8.64432 3.19515C8.78461 3.27628 8.89473 3.40081 8.9581 3.54998L10.8416 7.94478C10.8903 8.05845 10.9101 8.18241 10.8994 8.30561C10.8886 8.42882 10.8475 8.54744 10.7798 8.65093L9.22011 11.034C9.14912 11.1412 9.10716 11.265 9.09831 11.3933C9.08947 11.5216 9.11405 11.6499 9.16965 11.7659Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
